import React, { Component } from 'react';

import styles from './TinybopSchoolsMaterials.scss';

class TinybopSchoolsMaterials extends Component {
  render() {
    return (
      <div className="TinybopSchoolsMaterials">
        <a
          className="TinybopSchoolsMaterials__handbook"
          href="https://schools-cdn.tinybop.com/assets/handbooks/en/tinybop-coral-reef-handbook.pdf"
          target="_blank"
        >
          <img
            className="TinybopSchoolsMaterials__handbook-icon"
            src="https://www.funbrain.com/assets/img/sponsors/custom/TinybopSchools201809/TinybopSchools201809_handbook-thumb-coral-reef.png"
          />
          <div className="TinybopSchoolsMaterials__handbook-text">
            <p>
              <strong>CORAL REEF HANDBOOK</strong>
            </p>
            <p>
              Look to the handbook for supplementary information, interaction
              hints, questions, and answers.
            </p>
            <p className="TinybopSchoolsMaterials__link">VIEW</p>
          </div>
        </a>
        <div className="TinybopSchoolsMaterials__links">
          <a
            href="https://schools.tinybop.com/assets/printables/TinybopPrintables_CoralReef_FoodChains.pdf"
            className="TinybopSchoolsMaterials__link"
            target="_blank"
          >
            Food Chains: As You Play
          </a>
          <a
            href="https://schools.tinybop.com/assets/printables/TinybopPrintables_CoralReefFoodWeb.pdf"
            className="TinybopSchoolsMaterials__link"
            target="_blank"
          >
            Coral Reef Food Web: As You Play
          </a>
          <a
            href="https://schools.tinybop.com/assets/printables/TinybopPrintables_CoralRef_InvestigateReefAnimal.pdf"
            className="TinybopSchoolsMaterials__link"
            target="_blank"
          >
            Investigate a Reef Animal: As You Play
          </a>
          <a
            href="https://schools-cdn.tinybop.com/assets/printables/TinybopSchoolsPrintables_General_ConceptMap.pdf"
            className="TinybopSchoolsMaterials__link"
            target="_blank"
          >
            Concept Map: As You Play
          </a>
        </div>
      </div>
    );
  }
}

export default TinybopSchoolsMaterials;
